import { Card, CardContent, Typography, Box, CardActions } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const AvailableProductCard = ({ product, handleOpenDrawer }) => {
	const theme = useTheme();
	return (
		<Card
			sx={{
				height: '100%',
				cursor: 'pointer',
				border: `1px solid ${theme.palette.divider}`,
				backgroundColor: theme.palette.background.paper,
				'&:hover': { backgroundColor: theme.palette.action.hover },
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
			}}
			onClick={() => handleOpenDrawer(product)}
		>
			<CardContent>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Typography variant='h5' color={theme.palette.text.primary}>
						{product.name}
					</Typography>
					{product.logo_url && (
						<img
							src={product.logo_url}
							alt={`${product.name} logo`}
							style={{ width: '40px', height: '40px' }}
						/>
					)}
				</Box>
				{(product.short_description || product.description) && (
					<Typography
						color={theme.palette.text.secondary}
						sx={{
							display: '-webkit-box',
							WebkitLineClamp: '3',
							WebkitBoxOrient: 'vertical',
							overflow: 'hidden',
						}}
					>
						{product.short_description || product.description}
					</Typography>
				)}
			</CardContent>
			<CardActions>
				{/* <Button size="small" color="primary">
          Activate
        </Button> */}
			</CardActions>
		</Card>
	);
};

export default AvailableProductCard;
